export const environment = {
  production: true,
  buildId: '2103428779011811',
};
